import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { Crown, Heart } from "lucide-react";

export const SupporterLeaderboard = () => {
  const [data, setData] = useState({ supporters: [], tippers: [] });

  useEffect(() => {
    api.get("/leaderboard").then(({ data }) => setData(data)).catch(() => {});
  }, []);

  const total = (data.supporters?.length || 0) + (data.tippers?.length || 0);
  if (total === 0) return null;

  return (
    <section data-testid="supporter-leaderboard" className="mx-auto max-w-7xl px-4 py-8 sm:px-6">
      <div className="rounded-2xl border border-[#1E293F] bg-[#0F1424] p-6">
        <div className="flex items-center gap-2">
          <Crown size={18} className="text-[#FFB800]" />
          <h3 className="font-heading text-lg font-black tracking-tight text-white">Hall of Supporters</h3>
        </div>
        <p className="mt-1 text-sm text-[#94A3B8]">The people keeping the Wall of Shame running. Respect. 🫡</p>

        <div className="mt-5 grid gap-6 sm:grid-cols-2">
          <div data-testid="leaderboard-supporters">
            <div className="mb-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#FFB800]">
              <Crown size={13} /> Supporters
            </div>
            {data.supporters?.length ? (
              <div className="flex flex-wrap gap-2">
                {data.supporters.map((name, i) => (
                  <span key={i} className="inline-flex items-center gap-1 rounded-full border border-[#FFB800]/25 bg-[#FFB800]/10 px-3 py-1 text-sm font-semibold text-[#FFD666]">
                    <Crown size={12} /> {name}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-sm text-[#64748B]">Be the first Supporter 👑</p>
            )}
          </div>

          <div data-testid="leaderboard-tippers">
            <div className="mb-3 flex items-center gap-1.5 text-xs font-bold uppercase tracking-wider text-[#FF6B9D]">
              <Heart size={13} /> Tippers
            </div>
            {data.tippers?.length ? (
              <div className="flex flex-wrap gap-2">
                {data.tippers.map((name, i) => (
                  <span key={i} className="inline-flex items-center gap-1 rounded-full border border-[#FF6B9D]/25 bg-[#FF6B9D]/10 px-3 py-1 text-sm font-semibold text-[#FF9EBF]">
                    <Heart size={12} /> {name}
                  </span>
                ))}
              </div>
            ) : (
              <p className="text-sm text-[#64748B]">Drop a tip to show up here ♥</p>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};
